import { render, staticRenderFns } from "./ProfitSummary.vue?vue&type=template&id=febc89ce&scoped=true&"
import script from "./ProfitSummary.vue?vue&type=script&lang=js&"
export * from "./ProfitSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProfitSummary.vue?vue&type=style&index=0&id=febc89ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febc89ce",
  null
  
)

export default component.exports